import React, { useContext, useEffect, useState } from 'react'
import { useProfileInfoQuery } from '../../redux/API/portfolioApi';
import SideBar from '../Components/SideBar/SideBar';
import TextLinkExample from '../Components/NavBar/NavBar';
import { SidebarContext } from '../../context/SidebarContext';
import { AIFbaseUrl, baseUrl, cpbaseUrl, fmbaseUrl, rmbaseUrl } from '../../Constant/Matcher';

const AIFProfile = () => {
 const { isSiderbaropen } = useContext(SidebarContext);
  const [showLogout, setShowLogout] = useState(false);  
const [profileData, setProfileData] = useState("");
const userData = JSON.parse(localStorage.getItem("userData"));
  const role = (userData?.validateEmail && userData?.validateEmail[0]?.roledata[0]?.name) || 'AIF';
const getProfileApiUrl = () => {
    switch (role) {
        case "Client":
            return  `${baseUrl}profile`;
        case "CP":
            return `${cpbaseUrl}profile`
        case "RM":
            return `${rmbaseUrl}profile`;
        case "FM":
            return `${fmbaseUrl}profile`;
        case "AIF":
            return `${AIFbaseUrl}profile`;
        default:
            return `${baseUrl}profile`;
    }
};

const fetchProfileData = async () => {
  const apiUrl = getProfileApiUrl();
  
  try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userData.token}`,
        }
      })
      if (!response.ok) {
          throw new Error("Failed to fetch profile data");
      }
      const data = await response.json();
      setProfileData(data?.user);
      return data;
  } catch (error) {
      // console.error("Error fetching profile data:", error);
      return null;
  }
};
  useEffect(() => {
    fetchProfileData();
  }, []);

  

  return (
    <>
      <div className="App">
            <SideBar />
            <div className={!isSiderbaropen ? "pages" : "pages-change"}>
              <TextLinkExample setShowLogout={setShowLogout} />
              <div className="HomeCard "></div>
       <div className="card p-3 col-11  m-auto mt-3  ">
              <h4>Personal Information</h4>
              <form className="row g-3">
                <div className="col-md-6">
                  <label htmlFor="name" className="form-label fw-semibold">
                  First Holder Name
                  </label>
                 
                    <input
                      readOnly
                      type="text"
                      className="form-control"
                      id="name"
                      value={profileData?.name || profileData?.userid?.name}
                  
                      disabled
                    />
                
                </div>
                {
                  role === "AIF" && (

                <div className="col-md-6">
                  <label htmlFor="inputEmail4" className="form-label fw-semibold">
                  Second Holder Name
                  </label>
                  
                    <input
                      type="text"
                      className="form-control"
                      id="inputEmail4"
                      value={profileData?.secondholder}
                       readOnly
                      disabled
                    />
                 
                </div>
                  )
                }
                <div className="col-md-6">
                  <label htmlFor="inputEmail4" className="form-label fw-semibold">
                    Email
                  </label>
                  
                    <input
                      type="email"
                      className="form-control"
                      id="inputEmail4"
                      value={profileData?.email || profileData?.userid?.email}
                       readOnly
                      disabled
                    />
                 
                </div>
                <div className="col-md-6">
                  <label htmlFor="inputPassword4" className="form-label fw-semibold">
                    Mobile No.
                  </label>
                 
                    <input
                      type="text"
                      maxLength={10}
                      className="form-control"
                      id="inputPassword4"
                      value={profileData?.phone || profileData?.userid?.phone}
                      readOnly
                      disabled
                    />
                 
                </div>
               <div className="col-md-6">
                  <label htmlFor="inputPassword4" className="form-label fw-semibold">
                    PAN
                  </label>
                 
                    <input
                      type="text"
                      maxLength={10}
                      className="form-control"
                      id="inputPassword4"
                      value={profileData?.pan || profileData?.userid?.pan}
                      readOnly
                      disabled
                    />
                 
                </div>
               
               <div className="col-md-6">
                  <label htmlFor="inputPassword4" className="form-label fw-semibold">
                    Address
                  </label>
                 
                    <input
                      type="text"
                      maxLength={10}
                      className="form-control"
                      id="inputPassword4"
                      value={profileData?.city || profileData?.userid?.city}
                      readOnly
                      disabled
                    />
                 
                </div>
               
              </form>
            </div>
            </div>
            </div>
    </>
  )
}

export default AIFProfile